import { z } from 'zod';

export const batchTextUsersSchema = z.object({
  posEmployeeProfileIds: z.array(z.string()).min(1),

  body: z.string().min(1),
});

export type BatchTextUsersRequestBody = z.infer<typeof batchTextUsersSchema>;
